import { useQuery } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { listMcpConnectors } from '@/services/mcp-gateway';
import type { McpConnector } from '@/services/mcp-gateway';

export function useMcpConnectors() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery<McpConnector[]>({
    queryKey: ['mcp-connectors', orgId],
    queryFn: () => listMcpConnectors(orgId),
    enabled: !!orgId,
    staleTime: 30_000,
    retry: false,
  });
}
